export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff?a940d584750708f5435ce2c523498ddb";